export default __webpack_public_path__ + "static/media/Background_00104.4279c8cf.png";